export default {"src":"/_next/static/media/Anjoman.7176bdc0.svg","height":61,"width":54};